import { lazy } from "react";

const PreferencesPopup = lazy(() => import("@/components/popups/PreferencesPopup"));
const ChangedEmailPopup = lazy(() => import("@/components/popups/ChangedEmailPopup"));
const AddToNichePopup = lazy(() => import("@/components/popups/AddToNichePopup"));
const ReportPopup = lazy(() => import("@/components/popups/Report"));
const AddToCollectionPopup = lazy(() => import("@/components/popups/Collections"));
const EditNichePopup = lazy(() => import("@/components/popups/EditNichePopup"));
const EditNichesDialog = lazy(() => import("@/components/popups/EditNichesDialog"));
const GifPreferencePopup = lazy(() => import("@/components/popups/GifPreferencePopup"));
const ShareGifMenu = lazy(() => import("@/components/popups/ShareMenu"));
const MoreMenu = lazy(() => import("@/components/popups/MoreMenu"));
const NicheMoreMenu = lazy(() => import("@/components/popups/NicheMoreMenu"));
const CookieNoticeWrapper = lazy(() => import("@/components/popups/CookieNoticeWrapper"));
const EditGifPopup = lazy(() => import("@/components/popups/EditGifPopup"));
const AddToNicheSuccessPopup = lazy(() => import("@/components/popups/AddToNicheSuccessPopup"));
const AddDescriptionPopup = lazy(() => import("@/components/popups/AddDescriptionPopup"));
const AddToNicheConfirm = lazy(() => import("@/components/popups/AddToNicheConfirm"));
const CreateNichePopup = lazy(() => import("@/components/popups/CreateNichePopup"));

export enum PopupsEnum {
  Preferences = "preferences",
  ChangedEmail = "changedEmail",
  AddNiche = "addNiche",
  Report = "report",
  AddCollection = "addCollection",
  EditNiche = "editNiche",
  EditGifNiches = "editGifNiches",
  EditGifPreferences = "editGifPreferences",
  ShareGif = "shareGif",
  MoreMenu = "moreMenu",
  CookieNotice = "cookieNotice",
  EditGif = "editGif",
  NicheMoreMenu= "nicheMoreMenu",
  AddToNicheSuccess= "addToNicheSuccess",
  AddDescriptionPopup= "addDescriptionPopup",
  AddToNicheConfirm= "addToNicheConfirm",
  CreateNiche= "createNiche",
}

export const popups = {
  [PopupsEnum.Preferences]: PreferencesPopup,
  [PopupsEnum.ChangedEmail]: ChangedEmailPopup,
  [PopupsEnum.AddNiche]: AddToNichePopup,
  [PopupsEnum.Report]: ReportPopup,
  [PopupsEnum.AddCollection]: AddToCollectionPopup,
  [PopupsEnum.EditNiche]: EditNichePopup,
  [PopupsEnum.EditGifNiches]: EditNichesDialog,
  [PopupsEnum.EditGifPreferences]: GifPreferencePopup,
  [PopupsEnum.ShareGif]: ShareGifMenu,
  [PopupsEnum.MoreMenu]: MoreMenu,
  [PopupsEnum.CookieNotice]: CookieNoticeWrapper,
  [PopupsEnum.EditGif]: EditGifPopup,
  [PopupsEnum.NicheMoreMenu]: NicheMoreMenu,
  [PopupsEnum.AddToNicheSuccess]: AddToNicheSuccessPopup,
  [PopupsEnum.AddDescriptionPopup]: AddDescriptionPopup,
  [PopupsEnum.AddToNicheConfirm]: AddToNicheConfirm,
  [PopupsEnum.CreateNiche]: CreateNichePopup,
};
